import type {ReactElement} from 'react';
import {StylesInputPanel} from '@Panels/styles-input-panel/styles-input-panel';
import type {StylesInputLeftDrawerProps} from './styles-input-left-drawer.types';
import {noop} from '@Utils/general.util';
import {Drawer} from '@Components/drawer/drawer';

export function StylesInputLeftDrawer({isOpen, className = '', isAnchoredToParent = false, ...panelProps}: StylesInputLeftDrawerProps): ReactElement<StylesInputLeftDrawerProps> {
  return (
    <Drawer isOpen={isOpen} onClose={panelProps.onClose ?? noop} className={className} isAnchoredToParent={isAnchoredToParent}>
      <StylesInputPanel {...panelProps} />
    </Drawer>
  );
}
